import React, { useState, useEffect } from "react";
import {
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
  Label,
} from "reactstrap";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { ProfileService } from "../../../../../services/ProfileService";
import { JobService } from "../../../../../services/JobService";
import "../../../../../assets/css/overridestyles.css";
import { Stringutility } from "../../../../../utilities/stringutility";
import { Constants } from "../../../../../constants/constantValues";
const SoftSkills = (props) => {
  const [categories, setCategories] = useState([]);
  const [languageshow, setlanguageShow] = useState(true);
  const [ModalLong, setModalLong] = useState(false);
  const [scategories, setSCategories] = useState([]);
  const [selectedSoftSkills, setSelectedSoftSkills] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [modalRight, setModalRight] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [softSkillId, setSoftSkillId] = useState("");
  const [softSkillName, setSoftSkillName] = useState("");
  const [saveBtnEnabled, setSaveBtnEnabled] = useState(false);
  const [limit, setLimit] = useState(5);
  const [currentData, setCurrentData] = useState([]);
  const [skillListSize, setSkillListSize] = useState(0);
  const [selectedSoftSkillId, setSelectedSoftSkillId] = useState("");
  const [candidateTotalSoftSkills, setCandidateTotalSoftSkills] = useState([]);

  useEffect(() => {
    getTotalSoftSkillsList();
    getCandidateSoftSkillsList();
  }, []);

  const getTotalSoftSkillsList = () => {
    JobService.getSoftSkills().then((response) => {
      try {
        var skillDetails = response.data;
        if (skillDetails != null) {
          setCategories(response.data.skills);
          setFilteredCategories(response.data.skills);
        }
      } catch (err) {
        console.error("getSoftSkills" + JSON.stringify(err));
      }
    });
  };

  const getCandidateSoftSkillsList = () => {
    ProfileService.getProfileSoftSkills().then((response) => {
      try {
        var skillDetails = response.data;
        if (skillDetails != null) {
          if (skillDetails.skills !== null) {
            let softSkillsList = skillDetails.skills;
            if (softSkillsList.length > 0) {
              setCandidateTotalSoftSkills(softSkillsList);
              setSCategories(softSkillsList);
              setSkillListSize(softSkillsList.length);
              if (softSkillsList.length > 5) {
                setLimit(0);
              } else {
                var skillLimit = 5 - softSkillsList.length;
                setLimit(skillLimit);
              }
            } else {
              setCandidateTotalSoftSkills([]);
              setSCategories([]);
              setSkillListSize(0);
              setLimit(5);
            }
          } else {
            setSCategories([]);
            setSkillListSize(0);
            setLimit(5);
          }
        }
      } catch (err) {
        console.error("getProfileSoftSkills" + JSON.stringify(err));
      }
    });
  };

  const matchJobSoftSkills = (jobSoftSkills, candidateskills) => {
    let candidateJobSoftSkills = [];

    let jobSoftSkillDetails = jobSoftSkills;
    if (jobSoftSkillDetails !== null || jobSoftSkillDetails !== undefined) {
      if (jobSoftSkillDetails.length > 0) {
        const data = [];
        jobSoftSkillDetails.map((skill) => {
          skill.rating = 0;
          if (sessionStorage.getItem("removedSoftSkills") !== null) {
            var retrievedData = sessionStorage.getItem("removedSoftSkills");
            var removedList = JSON.parse(retrievedData);
            if (removedList.length > 0) {
              const isFound = removedList.some((element, index) => {
                if (element === skill.skillId) {
                  return true;
                }
                return false;
              });
              if (!isFound) {
                data.push(skill);
              }
            }
          } else {
            data.push(skill);
          }
        });
        const updatedJobDetails = [];
        for (let i = 0; i < data.length; i++) {
          let skill = data[i];
          if (candidateskills.length > 0) {
            const isFound = candidateskills.some((element, index) => {
              if (element.skillId === skill.skillId) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              updatedJobDetails.push(skill);
            }
          } else {
            updatedJobDetails.push(skill);
          }
        }
        candidateJobSoftSkills = [...updatedJobDetails];
      }
    }
    return candidateJobSoftSkills;
  };

  const handleCheck = (event, softSkills, position) => {
    var updatedList = [...selectedSkills];
    if (event.target.checked) {
      if (updatedList.length >= 5) {
        Stringutility.showErrorMessage(Constants.chooseSoftSkills);
      } else {
        setCurrentData([...currentData, softSkills.skillId]);
        updatedList.push(softSkills.skillId);
        selectedSoftSkills.push({
          skillId: softSkills.skillId,
        });
      }
    } else {
      for (var i = 0; i < selectedSoftSkills.length; i++) {
        if (selectedSoftSkills[i].skillId == softSkills.skillId) {
          selectedSoftSkills.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == softSkills.skillId) {
          updatedList.splice(i, 1);
        }
      }
      setCurrentData(currentData.filter((item) => softSkills.skillId !== item));
    }
    setSelectedSoftSkills(selectedSoftSkills);
    setSelectedSkills(updatedList);
  };

  const updatesoftskills = () => {
    const softskillsData = [];
    selectedSoftSkills.map((softskill) => {
      softskillsData.push({
        skillId: softskill.skillId,
      });
    });

    const softskillsobject = {
      skills: selectedSoftSkills,
    };

    if (selectedSoftSkills.length > 0) {
      setSaveBtnEnabled(true);
      ProfileService.updateSoftSkill(softskillsobject).then((response) => {
        setSaveBtnEnabled(false);
        try {
          setCurrentData([]);
          setSCategories([]);
          setModalRight(false);
          getCandidateSoftSkillsList();
        } catch (err) {
          console.error("updateSoftSkill" + JSON.stringify(err));
        }
      });
    } else {
      Stringutility.showErrorMessage(Constants.selectSoftSkill);
    }
  };

  const onAddSoftSkills = () => {
    setModalRight(true);
    setSelectedSoftSkills([]);
    setFilteredCategories(categories);
    setlanguageShow(true);
    setSelectedSkills([]);
    setCurrentData([]);
    resetSoftSkills(categories);
  };

  const resetSoftSkills = (categories) => {
    setFilteredCategories(categories);
    let selectedSkills = [];
    if (scategories.length > 0) {
      let updatedList = [];
      let selectedSoftSkillsList = [];
      scategories.map((category) => {
        selectedSkills.push(category.skillId);
        updatedList.push(category.skillId);
        selectedSoftSkillsList.push({
          skillId: category.skillId,
        });
      });
      setSelectedSkills(updatedList);
      setCurrentData(selectedSkills);
      setSelectedSoftSkills(selectedSoftSkillsList);
    }
  };

  const searchItems = (searchValue) => {
    if (searchValue !== "") {
      if (searchValue.length >= 3) {
        JobService.searchSoftSkill(searchValue).then((response) => {
          try {
            var languageDetails = response.data;
            if (languageDetails != null) {
              setFilteredCategories(languageDetails.skills);
              setlanguageShow(true);
            }
          } catch (err) {
            console.error("searchSoftSkill" + JSON.stringify(err));
          }
        });
      } else {
        setFilteredCategories(categories);
      }
    } else {
      setFilteredCategories(categories);
    }
  };

  const seeFullList = () => {
    setlanguageShow((prev) => !prev);
  };

  const handledeletesoftskill = (skill) => {
    let id = skill.id;
    let name = skill.name;
    let skillId = skill.skillId;
    setSoftSkillId(id);
    setSoftSkillName(name);
    setSelectedSoftSkillId(skillId);
    // setModalLong(true);
    removeSkillDetails(id, skillId);
  };

  const removeSkillDetails = (softSkillId, skillId) => {
    if (candidateTotalSoftSkills.length > 0) {
      ProfileService.deleteCandidateSkill(softSkillId).then((response) => {
        try {
          setSCategories([]);
          getCandidateSoftSkillsList();
          setModalLong(false);
        } catch (err) {
          console.error("deleteCandidateSkill" + JSON.stringify(err));
        }
      });
    } else {
      setSCategories([]);
      getCandidateSoftSkillsList();
      setModalLong(false);
    }
  };

  const updateDetails = () => {
    const skills = [];
    if (sessionStorage.getItem("removedSoftSkills") !== null) {
      var retrievedData = sessionStorage.getItem("removedSoftSkills");
      var removedList = JSON.parse(retrievedData);
      if (removedList.length > 0) {
        const data = [...removedList];
        const isFound = data.some((element) => {
          if (element === selectedSoftSkillId) {
            return true;
          }
          return false;
        });
        if (!isFound) {
          data.push(selectedSoftSkillId);
          sessionStorage.setItem("removedSoftSkills", JSON.stringify(data));
        }
      } else {
        skills.push(selectedSoftSkillId);
        sessionStorage.setItem("removedSoftSkills", JSON.stringify(skills));
      }
    } else {
      skills.push(selectedSoftSkillId);
      sessionStorage.setItem("removedSoftSkills", JSON.stringify(skills));
    }
  };

  const back = () => {
    setModalLong(false);
  };

  return (
    <div>
      <div>
        <Modal
          isOpen={modalRight}
          toggle={() => setModalRight(!modalRight)}
          wrapClassName="modal-right"
        >
          <ModalHeader>
            <div>
              <strong>Select your top 5 soft skills</strong>
            </div>
          </ModalHeader>
          <ModalBody className="labelSize">
            <div className="row mb-4">
              <div className="col-sm-12"></div>
            </div>
            {languageshow &&
              filteredCategories.length > 0 &&
              filteredCategories.map((skill, index) => {
                return (
                  <div className="mb-1" key={index}>
                    <div className="col">
                      <div className="tracbox">
                        <label className="terms">
                          <input
                            data-testid="softskills-privacypolicy"
                            type="checkbox"
                            className="input_skill"
                            checked={currentData.indexOf(skill.skillId) >= 0}
                            onChange={(e) => handleCheck(e, skill, index)}
                          />{" "}
                          {skill.name}
                        </label>
                      </div>
                    </div>
                  </div>
                );
              })}
          </ModalBody>
          <ModalFooter className="t-modal-footer-btn">
           
            <TeamanicsButton
              onClick={() => setModalRight(false)}
            >
              Cancel
            </TeamanicsButton>
            <TeamanicsButton
              onClick={updatesoftskills}
              disabled={saveBtnEnabled}
            >
              Save
            </TeamanicsButton>{" "}
          </ModalFooter>
        </Modal>
      </div>

      <Card className="mt-2 bg-primary-white min-sm:rounded-xl pt-12 mb-8 p-3">
        <CardBody className="t-body-padding[0px]">
          <div className="profile-card-title row">
            <div className="col-6">
              <label>
                <strong>Soft skills</strong>
              </label>
            </div>
            <div className="col-sm-6 t-button-flex-end ">
              <TeamanicsButton
                onClick={onAddSoftSkills}
              >
                {scategories.length >= 2 ? (
                  <> Add more soft skills</>
                ) : (
                  <> Add soft skills</>
                )}
              </TeamanicsButton>
            </div>
          </div>

          {scategories.length > 0 && (
            <>
              <div className="horizontal_line mt-1 mb-3" />
              {scategories.map((skill, index) => {
                return (
                  <div className=" mt-1" key={index}>
                    <Row>
                      <Colxx xxs="12">
                        <Form>
                          <FormGroup row>
                            <div className="col-10">
                              <Label>{skill.name}</Label>
                            </div>
                            <div className="col-2 mt-1">
                              <span to="">
                                <i
                                  type="button"
                                  color="black"
                                  className="simple-icon-trash edit-copyiconsize arrow-icon-color emp_icon"
                                  title="Delete Softskill"
                                  onClick={() =>
                                    // handledeletesoftskill(skill.id, skill.name)
                                    handledeletesoftskill(skill)
                                  }
                                />
                              </span>
                            </div>
                          </FormGroup>
                        </Form>
                      </Colxx>
                    </Row>
                  </div>
                );
              })}
            </>
          )}
        </CardBody>
      </Card>

      <Modal
        id="exampleModal"
        isOpen={ModalLong}
        toggle={() => setModalLong(!ModalLong)}
        twrapClassName="modal-right"
        className="file-model-width"
        aria-hidden="true"
      >
        <ModalHeader>
          <div>
            <label className="modal-title" id="exampleModalLabel">
              <strong>Delete softskill</strong>
            </label>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="modal-body">
            <label>
              Do you want to delete
              {softSkillName} soft skill?
            </label>
          </div>
        </ModalBody>

        <ModalFooter className="model-button ">
          <div>
            <TeamanicsButton color="primary" outline data-dismiss="modal" onClick={back}>
              Close
            </TeamanicsButton>{" "}
            <TeamanicsButton
              color="primary"
              outline
              data-dismiss="modal"
              onClick={() => {
                removeSkillDetails();
              }}
            >
              Delete
            </TeamanicsButton>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SoftSkills;
